import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { DebugService } from '~/shared/services/debug.service';
import * as fromActions from '@qvs/core/user';
import { CapacitorCookies } from '@capacitor/core';

// TODO 30-Nov-2023/tabe: enable SessionTimeoutInterceptor when retry is refactored to a generic solution
@Injectable()
export class SessionTimeoutInterceptor implements HttpInterceptor {
  constructor(
    private readonly store: Store,
    private readonly debugService: DebugService
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError(async (error: Error) => {
        if (
          error instanceof HttpErrorResponse &&
          [HttpStatusCode.Forbidden, HttpStatusCode.Unauthorized].includes(error.status)
        ) {
          this.debugService.logMessage(`response returned with status ${error.status} -> session expired`);
          await this.handleSessionIsInactive();
        }
        throw error;
      })
    );
  }

  private async handleSessionIsInactive() {
    await CapacitorCookies.clearAllCookies();
    this.store.dispatch(fromActions.checkUserSessionIsActiveFailure());
  }
}
